import {  useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { to: '/',             label: 'Home' },
  { to: '/researchers',  label: 'Researchers' },
  { to: '/institutions', label: 'Institutions' },
  { to: '/publishers',   label: 'Publishers' },
  { to: '/pricing',      label: 'Pricing' },
  { to: '/api-reference', label: 'Resources' },
  // { to: '/about',        label: 'About' },
];


export default function Navbar() {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  return (
    <nav className="sticky top-0 z-50 bg-white border-b border-gray-100 shadow-sm">
   <div className="w-full px-4 sm:px-6 lg:px-10">
        <div className="flex items-center justify-between h-16">

          {/* Logo */}
          <Link to="/" className="flex items-center gap-2.5 flex-shrink-0">
            <img src="/manna-plag-logo-horizontal.png?v=2" alt="Manna Plag" style={{ height: 36, objectFit: "contain" }} />
          </Link>

          {/* Desktop links */}
          <div className="hidden md:flex items-center gap-0.5">
            {navLinks.map(l => (
              <Link
                key={l.to}
                to={l.to}
                className={`text-[13px] px-3 py-2 rounded-lg transition-all font-medium ${
                  pathname === l.to
                    ? 'text-navy bg-blue-50 font-semibold'
                    : 'text-gray-700 hover:text-gray-900 hover:bg-gray-50'
                }`}
                style={{ fontFamily: 'Plus Jakarta Sans, Inter, sans-serif' }}
              >
                {l.label}
              </Link>
            ))}
          </div>

          {/* Auth buttons */}
          <div className="hidden md:flex items-center gap-2">
            <Link
              to="/login"
              className="text-[13px] font-medium text-gray-700 px-4 py-2 border border-gray-200 rounded-md hover:bg-gray-50 transition-colors"
              style={{ fontFamily: 'Plus Jakarta Sans, Inter, sans-serif' }}
            >
              Sign in
            </Link>
            <Link
              to="/register"
              className="text-[13px] font-semibold text-white bg-navy px-4 py-2 rounded-md hover:bg-navy-dark transition-colors shadow-sm"
              style={{ fontFamily: 'Plus Jakarta Sans, Inter, sans-serif' }}
            >
              Get started free
            </Link>
          </div>

          {/* Mobile toggle */}
          <button className="md:hidden p-2 text-gray-500" onClick={() => setOpen(!open)}>
            <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
              {open
                ? <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd"/>
                : <path fillRule="evenodd" d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z" clipRule="evenodd"/>
              }
            </svg>
          </button>
        </div>

        {open && (
          <div className="md:hidden py-3 border-t border-gray-100 flex flex-col gap-0.5">
            {navLinks.map(l => (
              <Link
                key={l.to}
                to={l.to}
                className={`text-[13px] font-medium px-3 py-2.5 rounded-lg transition-colors ${
                  pathname === l.to ? 'text-navy bg-blue-50 font-semibold' : 'text-gray-600 hover:bg-gray-50'
                }`}
                style={{ fontFamily: 'Plus Jakarta Sans, Inter, sans-serif' }}
                onClick={() => setOpen(false)}
              >
                {l.label}
              </Link>
            ))}

            <div className="flex gap-2 pt-3 border-t border-gray-100 mt-2">
              <Link to="/login"    className="text-[12px] font-medium text-gray-700 px-3 py-2 border border-gray-200 rounded-md">Sign in</Link>
              <Link to="/register" className="text-[12px] font-semibold text-white bg-navy px-4 py-2 rounded-md">Get started free</Link>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}
